import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { axiosInstance } from "@/pages/auth/auth.context";
import { AdminEventDetailDTO, EventPositionDTO } from "./types";
import EventDetailsPrint from "./EventDetailsPrint";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EventWithPositions extends AdminEventDetailDTO {
  eventPositions: EventPositionDTO[];
}

export default function EventDetailsPrintPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState<EventWithPositions | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEventDetails = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await axiosInstance.get<EventWithPositions>(
        `event/${id}`,
      );
      setEvent(response.data);
    } catch (err) {
      setError("Failed to load event details. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchEventDetails();
  }, [fetchEventDetails]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
        <p className="mt-4 text-lg">Loading event details...</p>
      </div>
    );
  }

  if (error || !event) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <p className="text-destructive text-lg font-bold mb-2">Error</p>
        <p className="text-muted-foreground mb-4">
          {error || "Event not found"}
        </p>
        <Button onClick={() => navigate(`/admin/events/${id}`)}>Back</Button>
      </div>
    );
  }

  return <EventDetailsPrint event={event} availablePositions={[]} />;
}
